import { AlertTriangle, UserRoundMinus, X } from 'lucide-react';
import { useDeleteAdmin } from '../hooks/useDeleteAdmin';

export const DeleteConfirmModal = (props) => {
  const { isDeleteModalOpen, setIsDeleteModalOpen, user } = props;
  const { mutate: deleteUser, isPending } = useDeleteAdmin();

  const handleDeleteUser = () => {
    deleteUser(user._id, {
      onSuccess: () => {
        setIsDeleteModalOpen(false);
      },
    });
  };

  if (!isDeleteModalOpen || !user) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm'>
      <div className='bg-card rounded-lg shadow-xl w-full max-w-md border border-border'>
        {/* Header */}
        <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
          <div className='flex items-center space-x-2'>
            <AlertTriangle className='text-destructive' size={20} />
            <h3 className='text-lg font-semibold text-foreground'>Confirm Delete</h3>
          </div>
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            className='text-muted-foreground hover:text-foreground transition-colors'
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className='p-6'>
          <p className='text-foreground mb-4'>
            Are you sure you want to delete <span className='font-semibold'>{user?.name}</span>? This action
            cannot be undone.
          </p>

          {/* Buttons */}
          <div className='flex space-x-3'>
            <button
              onClick={() => setIsDeleteModalOpen(false)}
              className='flex-1 px-4 py-2 border border-border rounded-md text-foreground hover:bg-accent transition-colors'
              disabled={isPending}
            >
              Cancel
            </button>
            <button
              onClick={handleDeleteUser}
              className='flex-1 px-4 py-2 bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
              disabled={isPending}
            >
              {isPending ? (
                <div className='flex items-center justify-center'>
                  <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-destructive-foreground mr-2' />
                  Deleting...
                </div>
              ) : (
                <div className='flex items-center justify-center'>
                  <UserRoundMinus size={16} className='mr-2' />
                  Delete User
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
